<script>
import Vue from "vue";
import {
  RichTextEditorPlugin,
  Toolbar,
  Link,
  Image,
  Count,
  HtmlEditor,
  QuickToolbar,
  Table,
} from "@syncfusion/ej2-vue-richtexteditor";
Vue.use(RichTextEditorPlugin);

export default {
  name: "ManagementNotesTab",

  data() {
    return {
      templates: [],
      templateID: 0,
      notes: {
        managementNotesId: 0,
        encounterId: this.$route.params.encounterID,
        patientID: this.$route.params.patientID,
        visitNo: this.$route.params.visitNO,
        userName: this.$root.username,
        managementNotes: ``,
        edit: true,
      },
    };
  },

  watch: {
    "$route.params.encounterID"() {
      this.fetchMFManagementNotes();
    },

    templateID() {
      if (!this.templateID) return;

      const templates = this.templates.filter(
        (temp) => temp.tempID == this.templateID
      );

      if (!templates.length) return;

      this.notes.managementNotes = templates[0].template;
    },
  },

  provide: {
    richtexteditor: [
      Toolbar,
      Link,
      Image,
      Count,
      HtmlEditor,
      QuickToolbar,
      Table,
    ],
  },

  mounted() {
    Promise.allSettled([this.fetchMFManagementNotes(), this.fetchTemplates()]);
  },

  methods: {
    fetchTemplates() {
      return this.$http
        .get(`MedicalFile/GetMedicalNotesTemplateNames`)
        .then((response) => {
          this.templates = response.data;
        })
        .catch(() => {});
    },

    saveData() {
      this.$root.loading = true;
      this.$http
        .post(`MedicalFile/MedicalFileManagementNotes`, this.notes)
        .then(() => {
          this.$root.loading = false;
        })
        .catch(() => {
          this.$root.loading = false;
        });
    },

    fetchMFManagementNotes() {
      if (!this.$route.params.encounterID) return Promise.reject();

      let url = `MedicalFile/GetPtMedicalFileManagementNotesForEncounter`;
      url += `?PatientID=${this.$route.params.patientID}`;
      url += `&VisitNo=${this.$route.params.visitNO}`;
      url += `&EncounterID=${this.$route.params.encounterID}`;

      return this.$http
        .get(url)
        .then(({ data }) => {
          this.notes = data.length
            ? data[0]
            : {
                managementNotesId: 0,
                encounterId: this.$route.params.encounterID,
                patientID: this.$route.params.patientID,
                visitNo: this.$route.params.visitNO,
                userName: this.$root.username,
                managementNotes: ``,
              };
        })
        .catch(() => {});
    },
  },
};
</script>
<template>
  <div class="w-full flex flex-col">
    <div class="md:w-1/4 sm:w-full p-1">
      <label for="grid-template" class="label-control">Template</label>
      <v-select
        class="text-xs bg-white"
        :options="templates"
        :reduce="(temp) => temp.tempID"
        v-model="templateID"
        label="tempName"
      ></v-select>
    </div>
    <div class="w-full p-tiny">
      <ejs-richtexteditor
        ref="managementNotesRTE"
        v-model="notes.managementNotes"
        :height="290"
        :disabled="
          ($root.formatLowercase($root.username) ==
            $root.formatLowercase(notes.userName) || $root.checkAuth('AdminEditMedicalFile'))
            ? false : true
        "
        :insertImageSettings="{ saveFormat: 'Base64' }"
        :toolbarSettings="{
          items: [
            'Bold',
            'Italic',
            'Underline',
            'StrikeThrough',
            'FontName',
            'FontSize',
            'FontColor',
            'BackgroundColor',
            'LowerCase',
            'UpperCase',
            'SuperScript',
            'SubScript',
            '|',
            'Formats',
            'Alignments',
            'OrderedList',
            'UnorderedList',
            'Outdent',
            'Indent',
            '|',
            'CreateTable',
            'CreateLink',
            'Image',
            '|',
            'ClearFormat',
            'SourceCode',
            'FullScreen',
            '|',
            'Undo',
            'Redo',
          ],
        }"
      />
    </div>
    <div class="w-full p-tiny text-right">
      <button
        v-if="($root.formatLowercase($root.username) ==
            $root.formatLowercase(notes.userName) || $root.checkAuth('AdminEditMedicalFile'))"
        class="btn-sm text-sm btn-primary rounded"
        @click.prevent="saveData"
      >
        <i class="fa fa-save"></i> Save
      </button>
    </div>
  </div>
</template>
